import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { RelationService, DragEvent } from '../relation.service';
import _ from 'lodash';
import { tap, takeUntil, debounceTime, map } from 'rxjs';
import { fromEvent, Subject } from 'rxjs';
import { BeFalseAfter } from '@root/util/decorator';
import { TranslateService } from '@root/shared/service/translate.service';
import { HostexModel, HouseModel } from '../base-house-relation/base-house-relation.component';
import { NzMessageService } from 'ng-zorro-antd/message';
import { CreateHouseTypeComponent } from '@root/router/component/property/create-house-type/create-house-type.component';
import { CreateHouseComponent } from '@root/router/component/property/create-house/create-house.component';
import { HttpClient } from '@angular/common/http';
import { UntypedFormBuilder, FormControl, UntypedFormGroup } from '@angular/forms';
import { LinkRoomTypeNoteComponent } from '../link-room-type-note/link-room-type-note.component';

@Component({
  selector: 'host-house-relation-left-panel',
  templateUrl: './house-relation-left-panel.component.html',
  styleUrls: ['./house-relation-left-panel.component.scss'],
})
export class HouseRelationLeftPanelComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('scrollContainer') scrollContainer: ElementRef;
  @Output() onClickItem = new EventEmitter();
  @Output() onTabChange = new EventEmitter();
  @Output() onUnlink: EventEmitter<{
    node: Node;
    data: {
      from: HostexModel;
      house: HouseModel;
    };
  }> = new EventEmitter();
  // @Output() onClickHouseType = new EventEmitter()
  @BeFalseAfter(1000) saveLoading = false;
  listOfHostexHouses: HostexModel[] = [];
  listOfHostexHouseTypes: HostexModel[] = [];
  tabIndex = 0;
  page = 1;
  pageSize = 50;
  // propertyCountInRoomType = 0; // 属于房型的房源数量
  displayPropertiesInRoomType = true;
  selectedItem: HostexModel;
  private hasMoreDataFlag = true;
  trackById = (index, item) => item.id;
  trackByLinkId = (i, item) => item.link_id;

  private destroy$ = new Subject();
  _currentHostexList: HostexModel[] = [];
  groupedHostexList; // 要展示的列表，分为独立房间和房型
  get currentHostexList() {
    return this._currentHostexList;
  }
  set currentHostexList(list) {
    this._currentHostexList = list;
    this.groupedHostexList = _.groupBy(list, (item) => (item['in_room_type'] ? 'in_room_type' : 'seperate'));

    console.log('groupedHostexList: ', this.groupedHostexList);
  }

  form: UntypedFormGroup = this.fb.group({
    keyword: null,
    group_id: null,
    house_tag: null,
  });

  optionsOfTag = [];
  optionsOfGroup = [];

  displayLinkRtNote = false;

  canTabDeactivate = (fromIndex, toIndex) => {
    if (toIndex === 1) {
      if (this.relationSrv.shouldDisplayLinkRtNote()) {
        this.displayLinkRtNote = true;
        return false;
      }
    }
    return true;
  };

  constructor(
    private relationSrv: RelationService,
    private fb: UntypedFormBuilder,
    private msg: NzMessageService,
    private t: TranslateService,
    private modal: NzModalService,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.initOptionsOfTag();
    this.initOptionsOfGroup();

    this.fetchHostexHouseList();
    this.fetchHostexHouseTypeList();

    this.subscribeFormChange();

    this.relationSrv.removeCardFromHostexRaw$.pipe(takeUntil(this.destroy$)).subscribe(({ card, hostex }) => {
      _.remove(hostex.card, (house) => house === card);
    });
    this.relationSrv.addCardToHostexRaw$.pipe(takeUntil(this.destroy$)).subscribe(({ card, hostex }) => {
      (hostex.card = hostex.card || []).push(card);
    });
  }

  ngAfterViewInit(): void {
    this.initScrollContainerListener();

    // this.modal.create({
    //   nzTitle: null,
    //   nzContent: LinkRoomTypeNoteComponent,
    //   nzClosable: false,
    //   nzMask: false,
    //   nzWidth: "100vw",
    //   nzStyle: { top: 0, bottom: 0 },
    // });
  }

  private subscribeFormChange() {
    this.form.valueChanges.subscribe((rst) => {
      console.log('rst: ', rst);
      if (this.tabIndex === 0) {
        this.fetchHostexHouseList();
      } else {
        this.fetchHostexHouseTypeList();
      }
    });
  }

  private initOptionsOfTag() {
    this.http.get('/api/house_status_setting/get').subscribe((rst: any) => {
      this.optionsOfTag = rst?.data?.house_tag
        .filter((t) => !t.delete_time)
        .map((t) => ({
          label: t.name,
          value: t.id,
        }));
    });
  }

  private initOptionsOfGroup() {
    this.http.get('/api/house_group/group_list').subscribe((res: any) => {
      const list = res?.data?.list ?? [];
      this.optionsOfGroup = list.map((item) => ({
        label: item.name,
        value: item.group_id,
      }));
      this.optionsOfGroup.unshift({ label: this.t.t('word.any'), value: null });
    });
  }

  private fetchHostexHouseList() {
    const form = this.form.value;
    const params = {
      keyword: form.keyword,
    };
    if (form.group_id) {
      Object.assign(params, { group_id: form.group_id });
    }

    this.selectedItem = null;
    // if (form.house_tag) {
    //   const [type, ids] = form.house_tag;
    //   Object.assign(params, {
    //     house_tag_type: type,
    //     house_tag_id: ids.join(","),
    //   });
    // }

    this.http.get('/api/listing_linking/properties', { params }).subscribe((res: any) => {
      // return this.syncService.getHostexList().subscribe((res) => {
      const list = _.get(res, 'data.list') || [];
      // this.houseVersion = res?.data?.version;
      this.listOfHostexHouses = this.updateHostexHouseList(list);
      // this.propertyCountInRoomType = this.listOfHostexHouses?.filter((item) => item.in_room_type)?.length;
      if (this.tabIndex === 0) {
        this.refreshCurrentHostexList();
        if (!this.selectedItem) {
          this.selectItem(this.currentHostexList?.[0]);
        }
      }
      console.log('hostex house list: ', this.listOfHostexHouses);
      // this.listOfHostexHouses = [];
    });
  }

  private fetchHostexHouseTypeList() {
    const form = this.form.value;
    const params = {
      keyword: form.keyword,
    };
    if (form.group_id) {
      Object.assign(params, { group_id: form.group_id });
    }
    if (form.house_tag) {
      const [type, ids] = form.house_tag;
      Object.assign(params, {
        house_tag_type: type,
        house_tag_id: ids.join(','),
      });
    }

    this.selectedItem = null;
    this.http.get('/api/listing_linking/room_types', { params }).subscribe((res: any) => {
      // return this.syncService.getHostexHouseTypeList().subscribe((res) => {
      const list = _.get(res, 'data.list') || [];
      // this.houseTypeVersion = res?.data?.version;
      this.listOfHostexHouseTypes = this.updateHostexHouseTypeList(list);
      if (this.tabIndex === 1) {
        this.refreshCurrentHostexList();
        if (!this.selectedItem) {
          this.selectItem(this.currentHostexList?.[0]);
        }
      }
      console.log('hostex house type list: ', this.listOfHostexHouseTypes);
      // this.listOfHostexHouseTypes = [];
    });
  }

  private updateHostexHouseTypeList(list: Array<any>): HostexModel[] {
    return list.map((item) => ({
      ...item,
      title: item.title,
      id: item.room_type_id,
      type: 'house_type',
      card: item.listings.map(
        (type) =>
          new HouseModel({
            type: 'house_type',
            // id: type.link_id, // 这个字段没有实际意义，历史原因，暂时保留
            link_id: type.link_id,
            origin_house_id: type.origin_house_id,
            title: type.title,
            inventory: type.inventory,
            thirdparty: type.thirdparty_type,
            previewUrl: type.cover_url,
            username: type.thirdparty_account?.username,
            account_id: type.thirdparty_account?.id,
            thumbnail: type.cover_url,
          })
      ),
    }));
    return list.map((item) => ({
      ...item,
      title: item.house_type_title,
      id: item.house_type_id,
      type: 'house_type',
      card: item.house_type_card.map((type) => ({
        ...type,
        model: new HouseModel({
          type: 'house_type',
          id: type.house_type_price_id,
          title: type.title,
          inventory: type.inventory,
          thirdparty: type.thirdparty_type,
          previewUrl: type.housing_link,
          username: type.username,
          thumbnail: _.get(type, 'cover.small_url'),
        }),
      })),
    }));
  }

  private updateHostexHouseList(list: Array<any>): HostexModel[] {
    return list.map((item) => ({
      ...item,
      title: item.title,
      id: item.property_id,
      in_room_type: item.in_room_type,
      type: 'house',
      card: item.listings.map(
        (house) =>
          new HouseModel({
            type: 'house',
            // id: house.link_id,
            link_id: house.link_id,
            origin_house_id: house.origin_house_id,
            title: house.title,
            inventory: house.inventory,
            thirdparty: house.thirdparty_type,
            previewUrl: house.cover_url,
            username: house.thirdparty_account?.username,
            account_id: house.thirdparty_account?.id,
            thumbnail: house.cover_url,
          })
      ),
    }));
    return list.map((item) => ({
      ...item,
      title: item.hostex_title,
      id: item.house_id,
      type: 'house',
      card: item.house_card.map((house) => ({
        ...house,
        model: new HouseModel({
          type: 'house',
          id: house.house_price_id,
          title: house.title,
          inventory: house.inventory,
          thirdparty: house.thirdparty_type,
          previewUrl: house.housing_link,
          username: house.username,
          thumbnail: _.get(house, 'picture_url.small_url'),
        }),
      })),
    }));

    _.forEach(list, (item) => {
      const card = item.house_card;
      _.forEach(card, (house) => {
        const __houseInfo = new HouseModel({
          id: house.house_price_id,
          title: house.title,
          inventory: house.inventory,
          thirdparty: house.thirdparty_type,
          previewUrl: house.housing_link,
          username: house.username,
          thumbnail: _.get(house, 'picture_url.small_url'),
        });

        _.assign(house, { __houseInfo });
      });
    });
  }

  initScrollContainerListener() {
    console.log('this.scrollContainer: ', this.scrollContainer);
    fromEvent(this.scrollContainer?.nativeElement, 'scroll')
      .pipe(takeUntil(this.destroy$), debounceTime(500))
      .pipe(map((rst: Event) => rst.target))
      .subscribe((rst: HTMLElement) => {
        const cacheHeight = 400;
        if (rst.scrollTop + rst.clientHeight + cacheHeight >= rst.scrollHeight) {
          this.onLoadMore();
        }
      });
  }
  onLoadMore() {
    if (this.hasMoreDataFlag) {
      this.page++;
      this.refreshCurrentHostexList();
    }
  }

  private selectItem(item) {
    this.selectedItem = item;
    this.relationSrv.selectHostexItemNotify(item);
  }

  private refreshCurrentHostexList() {
    let list = [];
    if (this.tabIndex === 0) {
      list = this.listOfHostexHouses;
    } else {
      list = this.listOfHostexHouseTypes;
    }
    this.currentHostexList = list.slice(0, this.page * this.pageSize);

    if (this.currentHostexList.length !== list.length) {
      this.hasMoreDataFlag = true;
    } else {
      this.hasMoreDataFlag = false;
    }
  }

  onClickHostexItem(item: HostexModel) {
    this.selectItem(item);

    // this.relationSrv.updateLeftPanelReceivingNode(node);
  }

  onCreate() {
    const modal = this.modal.create({
      // nzTitle: "创建房型",
      nzTitle: this.t.t(this.tabIndex === 0 ? 'house.create_house' : 'house.create_house_type'),
      nzContent: this.tabIndex === 0 ? CreateHouseComponent : (CreateHouseTypeComponent as any),
      nzFooter: null,
      nzWidth: 550,
      // nzComponentParams: {
      //   displaySuccessAlert: false,
      // },
    });
    modal.afterClose.subscribe((res) => {
      if (this.tabIndex === 0) {
        this.fetchHostexHouseList();
      } else {
        this.fetchHostexHouseTypeList();
      }
    });
  }

  /** @deprecated */
  onDrop(event: DragEvent, toHostex) {
    const dragData = event.dragData;

    if (dragData.from === 'hostex') {
      const fromHostex = dragData.hostex;
      if (fromHostex === toHostex) {
        return;
      }
      this.addCardToAnotherHostexHouse(dragData.house, fromHostex, toHostex);
    } else {
      this.addCardToHostexHouse(dragData.house, toHostex);
    }
  }

  /** @deptecated */
  onDropHouseType(event: DragEvent, toHostex) {
    const dragData = event.dragData;
    if (dragData.from === 'hostex') {
      const fromHostex = dragData.hostex;
      if (fromHostex === toHostex) {
        return;
      }
      this.addCardToAnotherHostexHouseType(dragData.house, fromHostex, toHostex);
    } else {
      this.addCardToHostexHouseType(dragData.house, toHostex);
    }
  }

  onTabIndexChange(index) {
    this.onTabChange.emit(index);
    this.relationSrv.activeTypeTab(index);
    this.page = 1;
    this.scrollContainer.nativeElement.scrollTop = 0;
    this.form.reset(
      {
        keyword: null,
        group_id: null,
        houst_tag: null,
      }
      // { emitEvent: false }
    );
    // this.refreshCurrentHostexList();

    // this.selectItem(this.currentHostexList?.[0]);
  }

  /** @deprecated */
  onRemoveHostexHouseCard(card, hostexHouse) {
    this.relationSrv.addCardToThirdpartyHouses(card);
    this.relationSrv.removeCardFromHostexHouse(card, hostexHouse);
  }

  /** @deprecated */
  onRemoveHostexHouseTypeCard(card, hostexHouse) {
    this.relationSrv.addCardToThirdpartyHouses(card);
    this.relationSrv.removeCardFromHostexHouseType(card, hostexHouse);
  }

  /** @deprecated */
  private addCardToAnotherHostexHouse(card, fromHostex, toHostex) {
    this.relationSrv.addCardToHostexHouse(card, toHostex);
    this.relationSrv.removeCardFromHostexHouse(card, fromHostex);
  }

  /** @deprecated */
  private addCardToAnotherHostexHouseType(card, fromHostex, toHostex) {
    this.relationSrv.addCardToHostexHouseType(card, toHostex);
    this.relationSrv.removeCardFromHostexHouseType(card, fromHostex);
  }

  /** @deprecated */
  private addCardToHostexHouse(house, hostexHouse) {
    this.relationSrv.addCardToHostexHouse(house, hostexHouse);
    this.relationSrv.removeCardFromThirdpartyHouses(house);
  }

  /** @deprecated */
  private addCardToHostexHouseType(card, hostexHouseType) {
    this.relationSrv.addCardToHostexHouseType(card, hostexHouseType);
    this.relationSrv.removeCardFromThirdpartyHouses(card);
  }

  onCloseLinkRtNote() {
    this.displayLinkRtNote = false;
  }

  onFinishLinkRtNote() {
    this.displayLinkRtNote = false;
    this.relationSrv.hideLinkRtNote();

    this.tabIndex = 1;
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
